var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1200,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#da121a",
    d: "M0 0h1200v600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcdd09",
    d: "M0 0h1200v400H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#078930",
    d: "M0 0h1200v200H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.66667 0 0 1.66667 600 300)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 120,
    fill: "#0f47af"
  }), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0-96-4.206 12.944 17.348 53.39h-23.13l-2.599 8h74.163l11.011-8H21.553Z",
    fill: "#fcdd09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.863-35.597 30.564-42.069",
    stroke: "#fcdd09",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(72)",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(144)",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(-144)",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(-72)",
    width: "100%",
    height: "100%"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEt);
export default __webpack_public_path__ + "static/media/et.24d4fb8d1d4024e29476d1177d5d3bef.svg";
export { ForwardRef as ReactComponent };